import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserService } from '../../services';
import { Router } from '@angular/router';

import { SharedValidators, CommonServices } from 'src/modules/shared';
import { Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { takeUntil, tap, map, distinctUntilChanged, debounceTime, delay } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Component({
	selector: 'app-email-verification',
	templateUrl: './email-verification.component.html',
	styleUrls: [ './email-verification.component.scss' ]
})
export class EmailVerificationComponent {
	formSubmitAttempt: boolean;
	pending: boolean;
	success: boolean;
	error: any;
	baseUrl;
	token;
	private unsubscribe$: Subject<void> = new Subject<void>();
	constructor(
		private userService: UserService,
		private route: ActivatedRoute,
		private commonServices: CommonServices,
		private http: HttpClient
	) {
		this.route.queryParams.subscribe((params) => {
			const token = params['token'];
			this.token = token;
			this.submitChange();
		});
		this.baseUrl = commonServices.baseUrl;
	}

	submitChange() {
		this.pending = true;
		this.userService
			.emailVerification({ token: this.token, body: JSON.stringify({}) })
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe(
				(res) => {
					this.pending = false;
					this.success = true;
				},
				(error) => {
					this.pending = false;
					this.error = error.error['userMessage'];
				}
			);
	}
}
